import { useEffect, useState } from 'react'
import { MdEvent } from "react-icons/md";
import { format } from 'date-fns';
import { RxCross1 } from 'react-icons/rx';
import { BsSearch } from 'react-icons/bs';
import { RiArrowDownSFill } from 'react-icons/ri';
import baseURL from '../../config/api';
import Pagination from '../../components/Pagination';
import { MdOutlineRemoveRedEye } from "react-icons/md";
import ViewMemberSchedule from './ViewMemberSchedule';
import moment from 'moment';
import useGroup from '../../hook/useGroup';
import { formatDateForDisplay } from '../../utils/getUserDateFormat';
import Cookies from 'js-cookie';

const formatTime = (time: string) => {
    if (!time) return "No time";
    const [hour, minute] = time.split(":");
    const h = parseInt(hour, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    const formattedHour = h % 12 || 12;
    return `${formattedHour}:${minute} ${ampm}`;
};

const heading = ["View", "Activity Name", "Date", "Start Time", "End Time", "Location", "Language"];

const MemberSchedule = () => {
    const token = Cookies.get("token-my-cdir");
    const { selectedGroupId }: any = useGroup();
    const [showEntries, setShowEntries] = useState<number>(10);
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [displayFilter, setDisplayFilter] = useState<boolean>(false);
    const [scheduleFilterValue, setScheduleFilterValue] = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
        page: 0,
        size: 10,
    });
    const [totalLength, setTotalLength] = useState<number>(0);
    const [selectedFilter, setSelectedFilter] = useState<string>("Activity Name");
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedScheduleId, setSelectedScheduleId] = useState<string | null>(null);

    useEffect(() => {
        if (!isFirstTime) {
            setSelectedFilter("Activity Name");
            setScheduleFilterValue(0);
            if (searchValue !== "") {
                setSearchValue("");
                setIsFirstTime(false);
            }
            else {
                setPaginationModel({
                    page: 0,
                    size: 10
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                size: paginationModel.size,
            };

            setPaginationModel(newPaginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false)
            apiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, selectedGroupId])

    const apiCall = (newPaginationModel: { page: number, size: number }) => {
        if (selectedGroupId > 0) {
            setIsDataLoaded(true);
            fetch(`${baseURL}schedules/GetCurrentUpcomingWeek/${moment().format("yyyy-MM-DD")},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
                headers: {
                    Authorization: `Bearer ${token?.toString()}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data.schedules.map((item: any) => ({
                        ...item,
                        date: item?.date ? formatDateForDisplay(item.date) : "No date",
                        startTime: item?.startTime ? formatTime(item.startTime) : "No time",
                        endTime: item?.endTime ? formatTime(item.endTime) : "No time"
                    }));

                    setSearchTableData(result);
                    setTotalLength(data.count);
                    setIsDataLoaded(false);
                })
                .catch((error) => {
                    console.log(error);
                    setIsDataLoaded(false);
                    setSearchTableData([]);
                    setTotalLength(0);
                });
        } else {
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
        }
    }

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    size: paginationModel.size,
                };

                setPaginationModel(newPaginationModel);

            }, 1000);
        }

        return () => clearTimeout(timeOutId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "" && !isFirstTime) {
            filteApiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const filteApiCall = (newPaginationModel: { page: number, size: number }) => {
        let filterData: any[] = [];
        setIsDataLoaded(true);
        if (selectedGroupId > 0) {
            switch (scheduleFilterValue) {
                case 0:
                    fetch(
                        `${baseURL}schedules/GetCurrentUpcomingWeekBySearch${moment().format("yyyy-MM-DD")},${selectedGroupId},${searchValue},${newPaginationModel.page},${newPaginationModel.size}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token?.toString()}`
                            }
                        }
                    )
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data.schedules.map((item: any) => {
                                return {
                                    ...item,
                                    date: item?.date ? format(new Date(item.date), "MM/dd/yyyy") : "No date",
                                    startTime: item?.startTime ? formatTime(item.startTime) : "No time",
                                    endTime: item?.endTime ? formatTime(item.endTime) : "No time"
                                };
                            })

                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setIsDataLoaded(false);

                        })
                        .catch((error) => {
                            console.log(error);
                            setIsDataLoaded(false);
                            setSearchTableData([]);
                            setTotalLength(0);
                        });
                    break;
            }
        }
        else {
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
        }
    }

    const applyFilter = () => {
        setSelectedFilter(() =>
            scheduleFilterValue === 0 ? "Activity Name" : ""
        );
        setSearchValue("");
        setDisplayFilter(false);
    };

    const clearFilter = () => {
        setSearchValue("");
        setDisplayFilter(false);
    };

    const viewSchedule = (id: string) => {
        setSelectedScheduleId(id);
        setShowModal(true);
    };

    useEffect(() => {
        const handler = () => setShowModal(false);
        window.addEventListener("closeEventModal", handler);
        return () => window.removeEventListener("closeEventModal", handler);
    }, []);

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal]);

    return (
        <section className="event__container overflow-x-hidden w-full p-3 xm:p-4">

            {/* HEADER */}
            <div className="w-full flex flex-col xm:flex-row justify-between items-start xm:items-center gap-3">
                <h1 className="px-2 xm:px-4 py-1.5 flex items-center gap-2">
                    <MdEvent fontSize={20} />
                    <span className="text-base xm:text-lg">Schedule</span>
                </h1>
            </div>

            {/* FILTER + SEARCH */}
            <div className="flex flex-col xm:flex-row gap-3 justify-between xm:items-center border border-black p-2 mt-4">
                <div className="relative flex flex-col xm:flex-row gap-3 items-start xm:items-center w-full">

                    {/* FILTER */}
                    <div className="relative w-full xm:w-auto">
                        <button
                            className="bg-secondary text-white px-3 py-2 xm:py-1 rounded-md flex items-center justify-between w-full xm:w-auto whitespace-nowrap"
                            onClick={() => setDisplayFilter(!displayFilter)}
                        >
                            {selectedFilter}
                            <RiArrowDownSFill className="ml-1" />
                        </button>

                        <div
                            className={`${displayFilter ? "block" : "hidden"
                                } absolute z-10 w-full xm:w-40 p-2 bg-white border border-black mt-2 xm:mt-0 xm:top-0 xm:left-full`}
                        >
                            <div className="flex justify-between">
                                <label className="text-xs font-bold" htmlFor="fields">
                                    Fields
                                </label>
                                <div
                                    onClick={() => setDisplayFilter(false)}
                                    className="w-4 h-4 cursor-pointer text-sm text-center"
                                >
                                    <RxCross1 />
                                </div>
                            </div>

                            <select
                                className="w-full text-xs py-1 border mt-1"
                                name="fields"
                                value={scheduleFilterValue}
                                onChange={(e) =>
                                    setScheduleFilterValue(parseInt(e.target.value))
                                }
                            >
                                <option value="0">Activity Name</option>
                            </select>

                            <div className="flex mt-2 justify-between">
                                <button
                                    className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                                    onClick={() => applyFilter()}
                                >
                                    Apply Filter
                                </button>

                                <button
                                    className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                                    onClick={() => clearFilter()}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* SEARCH */}
                    <div className="flex items-center gap-2 w-full border px-2 py-1 rounded">
                        <div className="h-4 w-4 text-gray-900">
                            <BsSearch />
                        </div>

                        <input
                            type="text"
                            placeholder="Search…"
                            className="w-full text-sm xm:text-lg pl-2 outline-none"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                        />
                    </div>

                </div>
            </div>

            <div className="my-2" />

            {!isDataLoaded ? (
                <>
                    {/* TABLE */}
                    <div className="w-full overflow-x-auto">
                        <table className="min-w-[700px] w-full bg-white">
                            <thead className="bg-gray-200 whitespace-nowrap">
                                <tr>
                                    {heading.map((item, index) => (
                                        <th
                                            key={index}
                                            className="px-4 xm:px-6 py-2 text-left text-xs xm:text-sm font-semibold text-black"
                                        >
                                            {item}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody className="whitespace-nowrap">
                                {searchTableData.length > 0 ? (
                                    searchTableData.slice(0, showEntries).map((item, index) => (
                                        <tr key={index} className="even:bg-blue-50">
                                            <td className="px-4 xm:px-6 py-2">
                                                <button
                                                    className="mr-4"
                                                    title="Edit"
                                                    onClick={() => viewSchedule(item.id)}
                                                >
                                                    <MdOutlineRemoveRedEye className="text-secondary text-xl" />
                                                </button>
                                            </td>
                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                {item?.activityName}
                                            </td>
                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                {item?.date}
                                            </td>
                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                {item?.startTime}
                                            </td>
                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                {item?.endTime}
                                            </td>
                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm break-words">
                                                {item?.location}
                                            </td>
                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                {item?.language || "Not specified"}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={9} className="px-2 py-1 text-sm font-medium text-center h-52">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {totalLength > 0 && (
                        <div className="mt-6 flex justify-center">
                            <Pagination
                                pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                                totalLength={totalLength}
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                showEntries={showEntries}
                                setShowEntries={setShowEntries}
                            />
                        </div>
                    )}
                </>
            ) : (
                <div className="min-w-full h-[300px] xm:h-[480px] flex justify-center items-center">
                    <div className="flex flex-col items-center">
                        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-r-transparent text-secondary"></div>
                        <span className="text-black text-sm mt-2">Loading...</span>
                    </div>
                </div>
            )}

            {/* MODAL */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-3">
                    <div className="bg-white w-full xm:w-[90%] md:w-[70%] lg:w-[60%] max-h-[90vh] overflow-y-auto rounded-lg shadow-lg relative">
                        {selectedScheduleId && (
                            <ViewMemberSchedule id={selectedScheduleId} />
                        )}
                    </div>
                </div>
            )}
        </section>
    )
}

export default MemberSchedule